import React, { Component } from "react";
import * as loginActions from "./actions";
import "./profile.css";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import GenTable from "./genTable";
import {
  Modal,
  Table,
  Tag,
  Divider,
  Button,
  Drawer,
  Form,
  Col,
  Row,
  Input,
  Select,
  message,
  DatePicker,
  Icon,
  Steps,
  Skeleton
} from "antd";

import UploadFile from './components/upload'

const { Step } = Steps;

const { Option } = Select;

class addStudent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isLoaded: false,
      currentStep:0,
      uploadStudentsModalVisible:false
    };
  }
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  showUploadModel = () => {
    this.setState({
      uploadStudentsModalVisible: true
    });
  };

  onCloseUploadModel = () => {

      this.setState({
        uploadStudentsModalVisible: false
      });
}
    
  onClose = () => {
    this.props.form && this.props.form.resetFields();
    this.setState({
      visible: false
    });
  };

  componentWillUnmount() {
    this.props.onUnload();
  }

  componentWillMount() {
    this.props.loadHODList();
  }
  render() {
    const loading = this.props.skeltonLoading
      ? this.props.skeltonLoading.show
      : true;
    const hodList =
      this.props.hodList &&
      Object.entries(this.props.hodList).length != 0 &&
      this.props.hodList.constructor === Object
        ? this.props.hodList
        : null;
    const profile = this.props.profile;

    const { getFieldDecorator, validateFields, resetFields } = this.props.form;

    const onValidateForm = e => {
      e.preventDefault();
      validateFields((err, values) => {
        if (!err) {
          this.props.addHOD(values);
          this.onClose();
        }
      });
    };

    return (
      <>
        <div
          
        >
          <h1 className="heading">Add New Students</h1>
          <Skeleton
            style={{ margin: 40, padding: 40 }}
            active={loading}
            loading={loading}
          >
            {hodList ? (
              <GenTable
                onDelete={this.props.removeHOD}
                showDrawer={this.showDrawer}
                props={this.props}
                data={hodList.data}
                showUploadModel={this.showUploadModel}
              />
            ) : null}
          </Skeleton>
        </div>

        <Modal
          title="Upload Students"
          visible={this.state.uploadStudentsModalVisible}
          destroyOnClose
          onCancel={this.onCloseUploadModel}
          mask
          bodyStyle={{ background: '#ECECEC', padding: '15px' }}
          width='70%'
          footer={null}
        >
          
              <UploadFile closeModel={this.onCloseUploadModel}/>

          {/* <CSVReader
            cssClass="react-csv-input"
            onFileLoaded={handleForce}
            parserOptions={papaparseOptions}
          /> */}

        </Modal>

        <Drawer
          title="Add new Student"
          width={720}
          bodyStyle={{padding:'20px'}}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Name">
                  {getFieldDecorator("name", {
                    initialValue: null,
                    rules: [{ required: true, message: "Please enter name" }]
                  })(<Input placeholder="Please enter name" />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="EMAIL (Same for Login)">
                  {getFieldDecorator("email", {
                    rules: [
                      {
                        type: "email",
                        required: true,
                        message: "Please enter  Email"
                      }
                    ]
                  })(
                    <Input
                      style={{ width: "100%" }}
                      addonBefore="Official email id"
                      placeholder="Please enter email"
                    />
                  )}
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item label="Roll Number">
                  {getFieldDecorator("rollnumber", {
                    rules: [
                      {
                        required: true,
                        message: "Please enter  student Roll Number"
                      }
                    ]
                  })(
                    <Input
                      style={{ width: "100%" }}
                      placeholder="Please enter RollNumber"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Campus">
                  {getFieldDecorator("campus", {
                    initialValue: profile && profile.campus && profile.campus,
                    rules: [{ required: true, message: "Please choose campus" }]
                  })(
                    <Select
                      placeholder="Please choose campus"
                      disabled={profile.role == "ADMIN" ? false : true}
                    >
                      <Option value="ADMIN">ADMIN</Option>
                      <Option value="BVRIT">BVRIT</Option>
                      <Option value="BVRITH">BVRITH</Option>
                      <Option value="VIT">VIT</Option>
                      <Option value="SVECW">SVECW</Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Department">
                  {getFieldDecorator("department", {
                    initialValue: profile && profile.branch && profile.branch,
                    rules: [
                      {
                        required: true,
                        message: "Please choose  department"
                      }
                    ]
                  })(
                    <Select
                      placeholder="Please choose  department"
                      disabled={
                        profile.role == "ADMIN" ||
                        profile.role == "PRINCIPAL" ||
                        profile.role == "HOD"
                          ? false
                          : true
                      }
                    >
                      <Option value="ECE">ECE</Option>
                      <Option value="CSE">CSE</Option>
                      <Option value="MECH">MECH</Option>
                      <Option value="EEE">EEE</Option>
                      <Option value="EIE">EIE</Option>
                      <Option value="IT">IT</Option>
                      <Option value="C&IT">C&IT</Option>
                      <Option value="MCA">MCA</Option>
                      <Option value="BCA">BCA</Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "100%",
              borderTop: "1px solid #e9e9e9",
              padding: "10px 16px",
              background: "#fff",
              textAlign: "right"
            }}
          >
            <Button onClick={this.onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" onClick={onValidateForm} htmlType="submit">
              Submit
            </Button>
          </div>
        </Drawer>
      </>
    ); // return <h1>{uid}</h1>;
  }
}

const mapStateToProps = state => {
    
  return {
    profile:
      state.firebase && state.firebase.profile ? state.firebase.profile : {},
    hodList: state.auth.hodList,
    skeltonLoading: state.loading,
    modelFromUploadStudents:state.auth.hodList.modelFromUploadStudents
  };
};

const mapDispachToProps = (dispatch, props) => ({
  addHOD: formval => {
    dispatch(loginActions.addHOD(formval));
  },
  removeHOD: email => {
    dispatch(loginActions.removeHOD(email));
  },
  loadHODList: () => {
    dispatch(loginActions.loadHODList());
  },
  onUnload: () => dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Form.create()(addStudent));
